import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import DetailsOperatorApplyScreen from "../DetailsOperatorApplyScreen";
import * as NavigationService from '../../../../../redux/NavigationService';
import HMAlert from "../../../../../customviews/HMAlert";
import i18n from "../../../../../I18n/i18n";
import {Tools} from "../../../../../tools/Tools";


const mapStateToProps = (state) => ({
    results: state.reducerDetailsOperatorApplyScreen.results,
    isLoading: state.reducerDetailsOperatorApplyScreen.isLoading,
    NoInternetDialog: state.reducerDetailsOperatorApplyScreen.NoInternetDialog,

    resultsSet: state.reducerDetailsOperatorApplyScreen.resultsSet,
    isLoadingSet: state.reducerDetailsOperatorApplyScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerDetailsOperatorApplyScreen.NoInternetDialogSet,

    position: state.reducerDetailsOperatorApplyScreen.position,
    id_category: state.reducerDetailsOperatorApplyScreen.id_category,


    positionPersonnel: state.reducerDetailsOperatorApplyScreen.positionPersonnel,
    id_Personnel: state.reducerDetailsOperatorApplyScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    token: state.reducerSplashGetAllData.token,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
    ListSend: state.reducerListOperatorApplyScreen.ListSend,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetDetailsOperatorApplyScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetDetailsOperatorApplyScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('customValue', params.customValue);
    //   formData.append('state_params', params.state_params);
    formData.append('_session', params._session == null ? '' : params._session);

    if (params.type) {
        formData.append('_session', params._session == null ? '' : params._session);
        formData.append('token_mahale', store.getState().reducerSplashGetAllData.tokenMahaleh);
        formData.append('IsCurrentPlan', params.IsCurrentPlan);
        formData.append('CurrentPlanCost', params.CurrentPlanCost);
        formData.append('CurrentPlanDate', params.CurrentPlanDate);
        formData.append('IsNextPlan', params.IsNextPlan);
        formData.append('NextPlanCost', params.NextPlanCost);
        formData.append('NextPlanCost', params.NextPlanCost);
        formData.append('description', params.description);


        formData.append('record', params.record);
        formData.append('ganttime', params.ganttime);
        formData.append('type', params.type);
        formData.append('status', params.status);

        Tools.addAllFormData(formData,true)

        /*  "IsCurrentPlan": indexSelectCheckBoxProgramNow,
              "CurrentPlanCost": TextInputCostProgramNow,
              "CurrentPlanDate": TextInputProgramNow,

              "IsNextPlan": indexSelectCheckBoxProgramFuture,
              "NextPlanCost": TextInputProgramFuture,
              "NextPlanDate": TextInputCostProgramFuture,

              "ganttime": i18n.locale,
              "type": type,
              "status": i18n.locale,*/
    }

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        }
    };


    /*  axios(
          {
              // url: baseUrl + url + params,
              //url: url + "&after=0000-00-00",
              // url: url+`&${params.page}&${params.after}` ,
              url: url + params,
              // params:params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    axios.post(url, formData, config)

    // axios(
    //     {
    //         // url: baseUrl + url + params,
    //         // url: url+"&after=0000-00-00" ,
    //         url: baseUrlWP + url,
    //         method: typeConnection,
    //         params: params,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         timeout: typeExport._TIMEOUT,
    //         /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
    //     }
    // )
        .then(response => {
                let data = response.data;
                switch (type) {
                    case typeExport.TypeGetDetailsOperatorApplyScreen:
                        //if (response.data.status === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccess(data));
                        if (response.data.success) {
                            NavigationService.navigateParams("SubmitSwitchingOperationScreen", {
                                item: params.state_params.item,
                                res: data
                            })
                        }
                        else {
                            HMAlert(
                                i18n.t('constant.message'),
                                response.data.message ? response.data.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {

                                            //    NavigationService.navigatereset("ApplyScreen", {item: item})
                                        }
                                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                                        , style: 'cancel'
                                    },

                                ],
                                {cancelable: true}
                            )
                        }

                        //   NavigationService.navigatereset('MainStack');
                        // }
                        // else {
                        //  //   NavigationService.navigatereset('LoginStack');
                        // }
                        break;

                    case typeExport.TypeSendGetDetailsOperatorApplyScreen:
                        //if (response.data.status === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccess(data));
                        if (response.data.success) {
                            NavigationService.navigateParams("SubmitSendOperationScreen", {
                                item: params.state_params.item,
                                res: data
                            })
                        }
                        else {
                            HMAlert(
                                i18n.t('constant.message'),
                                response.data.message ? response.data.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {

                                            //    NavigationService.navigatereset("ApplyScreen", {item: item})
                                        }
                                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                                        , style: 'cancel'
                                    },

                                ],
                                {cancelable: true}
                            )
                        }

                        //   NavigationService.navigatereset('MainStack');
                        // }
                        // else {
                        //  //   NavigationService.navigatereset('LoginStack');
                        // }
                        break;

                    case typeExport.TypeSetDetailsOperatorApplyScreen :
                        if (response.data.success) {
                            dispatch(serviceActionSuccessSet(data));
                            global._refreshListOpertor = true;

                            NavigationService.Pop();
                        }
                        else {
                            dispatch(serviceActionErrorSet(e))

                            HMAlert(
                                i18n.t('constant.message'),
                                response.data.message ? response.data.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {

                                            //    NavigationService.navigatereset("ApplyScreen", {item: item})
                                        }
                                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                                        , style: 'cancel'
                                    },

                                ],
                                {cancelable: true}
                            )
                        }

                        break;

                    default:
                }
            }
        ).catch((e) => {

        switch (type) {
            case typeExport.TypeGetDetailsOperatorApplyScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetDetailsOperatorApplyScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
                dispatch(serviceActionError(e))
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetDetailsOperatorApplyScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        }
        else {
            switch (type) {
                case typeExport.TypeGetDetailsOperatorApplyScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetDetailsOperatorApplyScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetDetailsOperatorApplyScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.DetailsOperatorApplyScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(DetailsOperatorApplyScreen);
